<template>
  <FaIcon :icon="['fas', 'truck']" />
</template>
